import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

import { tw } from "@/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  icon?: React.ReactNode;
}

export const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ error, icon, ...inputProps }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => setShowPassword((prevState) => !prevState);
    return (
      <div className="relative flex items-center">
        <input
          type={showPassword ? "text" : "password"}
          ref={ref}
          {...inputProps}
          className={tw(
            "h-12 w-full rounded-lg border px-4 py-3 text-primary-950 shadow-sm placeholder:text-neutral-500",
            error ? "border-error-700" : "border-neutral-200",
            "hover:border-primary-200",
            "focus:border-primary-300 focus:shadow-focus focus:outline-none",
            icon && "pl-8",
          )}
        />
        <button
          type="button"
          onClick={toggleShowPassword}
          className="absolute inset-y-0 right-3 my-auto size-4 text-primary-500"
        >
          {showPassword ? <Eye /> : <EyeOff />}
        </button>
      </div>
    );
  },
);

PasswordInput.displayName = "PasswordInput";
